import { observer } from 'mobx-react';
import React, { Fragment, useRef } from 'react';
import './PopUpForm.scss';


const flexItemCol1 = {
  flex: 1,
  display: 'flex',
};

const flexItemCol2 = {
  flex: 1,
  display: 'flex',
};


const PopUpComp = ({ formData, onFormChange, callFrom }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updatedData = { ...formData, [name]: value };
    onFormChange(updatedData);
  };

  return (

    <div className="popup-container col">
      {callFrom === "WDTReport" ? 
      <div className=''>
         <h3 className="soil-stress-header" tabIndex={0}>
         Report Title Block Information
       </h3>
      <div className="form-row-fixed-height">
      <div style={flexItemCol1}>
        <label className="grid-col-3 usa-label" htmlFor="designedByName"
          style={{ paddingRight: '155px' }}
        >Designed By&nbsp;</label>
        <input className="grid-col-12 usa-input" type="text" name="designedByName"
          style={{ width: '240px' }} aria-label='designedByName'
          value={formData.designedByName} onChange={handleInputChange}
        />
      </div>
      <div style={flexItemCol2}>
        <label className="usa-label" htmlFor="designedByDate"
          style={{ width: '50px' }} aria-label='designed by date'
        >
          Date</label>
        <input type="text" name="designedByDate"
          style={{ width: '100px' }}
          value={formData.designedByDate} onChange={handleInputChange}
          />
      </div>
      </div> 
      <div className="form-row-fixed-height">
      <div style={flexItemCol1}>
        <label className="grid-col-3 usa-label" htmlFor="checkedByName"
          style={{ paddingRight: '155px' }} aria-label='checked by name'
        >Checked By&nbsp;&nbsp;</label>
        <input className="grid-col-12 usa-input" type="text" name="checkedByName"
          style={{ width: '240px' }}
          value={formData.checkedByName} onChange={handleInputChange}
        />
      </div>
      <div style={flexItemCol2}>
        <label className="usa-label" htmlFor="checkedByDate"
          style={{ width: '50px' }}
        >
          Date</label>
        <input type="date" name="checkedByDate"
          style={{ width: '100px' }} aria-label='checked by date'
          value={formData.checkedByDate} onChange={handleInputChange}
        />
      </div>
      </div>
      <div className="form-row-fixed-height">
      <div style={flexItemCol1}>
        <label className="grid-col-3 usa-label" htmlFor="approvedByName"
          style={{ paddingRight: '155px' }} 
        >Approved By</label>
        <input className="grid-col-12 usa-input" type="text" name="approvedByName"
          style={{ width: '240px' }} aria-label='approved by name'
          value={formData.approvedByName} onChange={handleInputChange}
        />
      </div>
      <div style={flexItemCol2}>
        <label className="usa-label" htmlFor="approvedByDate"
          style={{ width: '50px' }}
        >
          Date</label>
        <input type="date" name="approvedByDate"
          style={{ width: '100px' }} aria-label='approved by date'
          value={formData.approvedByDate} onChange={handleInputChange}
        />
      </div>
      </div>  
      </div>
          :
      <div className="">
        <h3 className="soil-stress-header" tabIndex={0}>
          Report Title Block Information
        </h3>
        <div className="form-row-fixed-height">
          <label className="grid-col-3 usa-label pr-3" htmlFor="alignmentName"
            style={{ width: '200px' }}
          >
            Name
          </label>
          <input type="text" className="grid-col-12 usa-input" name="name" value={formData.name} onChange={handleInputChange} aria-label='name' />
        </div>

        <div className="form-row-fixed-height">
          <div style={flexItemCol1}>
            <label className="grid-col-3 usa-label" htmlFor="designedByName"
              style={{ paddingRight: '155px' }}
            >Designed By</label>
            <input className="grid-col-12 usa-input" type="text" name="designedByName"
              style={{ width: '240px' }} aria-label='designedByName'
              value={formData.designedByName} onChange={handleInputChange}
            />
          </div>
          <div style={flexItemCol2}>
            <label className="usa-label" htmlFor="designedByDate"
              style={{ width: '50px' }}
            >
              Date</label>
            <input type="text" name="designedByDate"
              style={{ width: '100px' }}
              value={formData.designedByDate} onChange={handleInputChange} aria-label='designed by date'
            />
          </div>
        </div>


        <div className="form-row-fixed-height">
          <label className="grid-col-3 usa-label pr-3" htmlFor="practice"
            style={{ width: '200px' }}
          >
            Practice
          </label>
          <input type="text" className="grid-col-12 usa-input" name="practice" value={formData.practice} onChange={handleInputChange} aria-label='practice'/>
        </div>

        <div className="form-row-fixed-height">
          <label className="grid-col-3 usa-label pr-3" htmlFor="location"
            style={{ width: '200px' }}
          >
            Location
          </label>
          <input type="text" className="grid-col-12 usa-input" name="location" value={formData.location} onChange={handleInputChange} aria-label='location' />
        </div>

        <hr></hr>

        <div className="">

          <h3 className="soil-stress-header">Project Information</h3>
        </div>

        <div className="form-row-fixed-height">
          <label className="grid-col-3 usa-label pr-3" htmlFor="description"
            style={{ width: '200px' }}
          >
            Description
          </label>
          <input type="text" className="grid-col-12 usa-input" name="description" value={formData.description} onChange={handleInputChange} aria-label='description'/>
        </div>
      </div>
      }

    </div >

  );
};

export const PopUpComponent = observer(PopUpComp);
